
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
    RadioButton,
    ProgressBar,
} from "@gpstrackit/react-controls";

import { Chip } from "@mui/material";
import { getCerebrumXOEMs } from 'Core/data/Helpers';
import CustomSelect from 'Components/Select';


//Notification
import { NotificationManager } from "Components/Notifications";

//Styles
import './addIntegration.scss';

//Actions
import {
    addIntegrationGetIntegrationsRequest,
    addCompanyIntegrationRequest,
    addIntegrationCerebrumXGetFleetsRequest,
    addIntegrationRequest,
    clearRedux,
} from 'Redux/actions';


import { getAccounts } from './redux/saga'
import { id } from "date-fns/locale";

const AddIntegration = (props) => {
    const { tableRef, companyIntegrations, company } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    //Redux States
    const { loading, openModal, result, integrations, allFleets } = useSelector(state => state.addIntegrationRedux)

    //Local States
    const [step, setStep] = useState(1);
    const [integration, setIntegration] = useState(null);
    const [oem, setOem] = useState(null);
    const [fanId, setFanId] = useState(null);
    const [fleet, setFleet] = useState(null);
    const [account, setAccount] = useState(null);

    const closeModal = () => {
        setStep(1);
        setIntegration(null);
        setFleet(null);
        setAccount(null);
        dispatch(clearRedux("ADD_INTEGRATION"));
    }


    const applyChanges = () => {

        let payload = {}
        switch (integration?.code) {
            case "cerebrumX":
                payload = {
                    companyId: company?.id,
                    integrationId: integration?.id,
                    parameters: JSON.stringify(fleet),
                    status: fleet.fleetStatus,
                    fleetId: fleet.fleetId
                }
                break;
            case "diesellaptops":

                break;
            case "wex-ws":
                break;
            case "zonar":
                payload = {
                    companyId: company?.id,
                    integrationId: integration?.id,
                    parameters: JSON.stringify({ id: account?.id })
                }

                break;
            case "busSuite":
                payload = {
                    companyId: company?.id,
                    integrationId: integration?.id
                }
                break;
            default:
                break;
        }

        dispatch(addCompanyIntegrationRequest(payload))

    }

    const getIntegrationView = () => {
        switch (integration?.code) {
            case "cerebrumX":
                return getCerebrumX();
            case "diesellaptops":
                break;
            case "wex-ws":
                break;
            case "zonar":
                return getZonar();
            default:
                return getDefaultView();
        }

    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            callback(response)
        })
    }

    const getCerebrumX = () => {
        return (
            <div style={{ padding: '0 10px', height: '78vh' }}>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['add_integration_select_account']}</label>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <div className="time-zone-container" style={{ margin: 10 }}>
                            <Select
                                id="allFlets"
                                value={fleet}
                                options={allFleets}
                                label={messages['add_integration_account']}
                                required
                                requiredMessage={messages['required_field']}
                                onChange={(value) => setFleet(value)}
                                valueField="fleetId"
                                textField="name"
                                placeholder={messages['add_integration_account']}
                            />
                        </div>
                    </Grid>
                    {/* 
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['add_integration_select_manufacturers']}</label>
                    </Grid>

                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <div style={{ marginTop: 10 }}>
                            {
                                getCerebrumXOEMs()?.map((item, index) => {
                                    return (
                                        <Chip
                                            onClick={(() => {
                                                setOem(item);
                                            })}
                                            style={{
                                                marginRight: 5,
                                                cursor: 'pointer',
                                                backgroundColor: oem === item ? '#1D2734' : "#00000014",
                                                color: oem === item ? 'white' : "#000000de"
                                            }}
                                            label={item}
                                        />
                                    )
                                })
                            }
                        </div>
                    </Grid>
                    {
                        oem === "GM" &&
                        <Grid item xs={12} style={{ marginTop: 10 }}>
                            <Input
                                type="text"
                                label={messages['add_oem_fanid']}
                                placeholder={messages['add_oem_fanid']}
                                autoComplete="new-password"
                                value={fanId}
                                onChange={(value) => setFanId(value)}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={20}
                                minLength={3}
                                minLengthMessage={`${messages['add_oem_fanid_min']} 3`}
                                maxLengthMessage={`${messages['add_oem_fanid_max']} 20`}
                            />
                        </Grid>
                    } */}
                </Grid>
            </div>
        )
    }

    const getZonar = () => {
        return (
            <div style={{ padding: '0 10px', height: '78vh' }}>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['add_integration_select_account']}</label>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <div className="time-zone-container" style={{ margin: 10 }}>
                            <Grid item xs={12}>
                                <CustomSelect
                                    async
                                    value={account}
                                    onChange={(newaccount) => setAccount(newaccount)}
                                    label={messages['add_integration_account']}
                                    loadOptions={getAccountsForSelect}
                                    required
                                    getOptionLabel={e => e.name}
                                    getOptionValue={e => e.id}
                                    placeholder={messages['add_integration_account']}
                                    requiredMessage={messages['required_field']}
                                    isClearable
                                />
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }

    const getDefaultView = () => {
        return (
            <div style={{ padding: '0 10px', height: '78vh' }}>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} style={{ marginTop: 10 }}>
                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['add_integration_click_message']}</label>
                    </Grid>
                </Grid>
            </div>
        )
    }

    useEffect(() => {

        if (result) {
            dispatch(clearRedux("add_integration", { result: null }))
            if (!result?.error) {
                NotificationManager.success(
                    messages['add_integration_success_message'],
                    messages['add_integration_title'],
                    3000
                );

                closeModal();

                tableRef && tableRef?.current?.getData();
            } else {
                NotificationManager.error(
                    messages['add_integration_error_message'],
                    messages['add_integration_title'],
                    3000
                );

            }
        }
    }, [result])

    useEffect(() => {
        dispatch(addIntegrationGetIntegrationsRequest())
    }, [])

    return (
        <Modal
            open={openModal}
            title={`${messages['add_integration_title']} ${integration ? ` - ${integration?.name}` : ''}`}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <ProgressBar steps={2} activeStep={step - 1} />
                {
                    step === 1 &&
                    <div style={{ padding: '0 10px', height: '78vh' }}>
                        <Grid
                            container
                            spacing={1}
                        >

                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['add_integration_type']}</label>
                            </Grid>
                            {
                                integrations?.map((item, index) => {

                                    if (!companyIntegrations?.find(i => i?.integration?.code === item.code)) {
                                        if (item.code === "cerebrumX" || item.code === "zonar" || item.code === "busSuite") {
                                            let label = messages[`add_integration_${item.code}`]
                                            return (
                                                <Grid item xs={12} key={index} style={{ marginTop: 10 }}>
                                                    <RadioButton
                                                        onChange={(value) => {
                                                            setIntegration(item);
                                                        }}
                                                        value={integration?.code === item?.code}
                                                        label={label ? label : item.name}
                                                        position="end"
                                                    />
                                                </Grid>
                                            )
                                        }
                                    }
                                })
                            }
                        </Grid>
                    </div>
                }
                {
                    step === 2 &&
                    <div style={{ padding: '0 10px', height: '78vh' }}>
                        {
                            getIntegrationView()
                        }
                    </div>
                }

            </ModalBody>
            <ModalFooter>
                {
                    <Button
                        className="btn-cancel"
                        onClick={() => closeModal()}
                    >
                        {messages['common_cancel']}
                    </Button>
                }
                {
                    step === 2 &&
                    <Button
                        className="btn btn-cancel btn-gray"
                        onClick={() => setStep(step - 1)}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    className="btn-dark-blue"
                    disabled={!integration || ((step === 2 && (integration.code === "cerebrumX" && !fleet)))}
                    onClick={() => {
                        if (step === 2 && integration.code.toUpperCase() === "ZONAR") {
                            if (!account) {
                                NotificationManager.error(
                                    messages['add_integration_account_required'],
                                    messages['add_integration_title'],
                                    3000
                                );
                                return
                            } else {
                                applyChanges()
                            }
                        } else if (step === 2)
                            applyChanges()
                        else {
                            setStep(step + 1)
                            if (integration.code === "cerebrumX")
                                dispatch(addIntegrationCerebrumXGetFleetsRequest())
                        }
                    }}
                >
                    {step === 2 ? messages['add_integration_save_integration'] : messages['common_next']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default AddIntegration;